/**
 * Mã field phép (leave_field) hard-code trên biểu mẫu phiếu nghỉ phép.
 * Các giá trị phải trùng khớp với cấu hình backend `annual-leave.field-codes.*`
 * (xem `workflow_be/src/main/resources/config/application.yml`).
 *
 * - Nhóm hiển thị (chỉ đọc, tự động điền từ quỹ phép — gộp phép năm + phép tồn):
 *   ENTITLED_DAYS (theo chế độ), USED_DAYS (đã nghỉ), REMAIN_DAYS (còn lại)
 * - Nhóm nhập liệu (đọc để tính phép): LEAVE_DAYS, LEAVE_START_DATE, LEAVE_END_DATE
 * - Nhóm hiển thị tự tính từ khoảng ngày (chuỗi mô tả, KHÔNG phải số): ACTUAL_LEAVE_DAYS
 *   (tổng số ngày nghỉ thực tế, gồm cả Thứ Bảy/Chủ Nhật/ngày lễ)
 *
 * Tách riêng khỏi `leave-fund.service.js` để module này không kéo theo chuỗi
 * phụ thuộc nặng (axios/store), giúp tái sử dụng và kiểm thử đơn vị dễ dàng.
 */
export const LEAVE_FIELD_CODES = Object.freeze({
	ENTITLED_DAYS: "so_ngay_duoc_nghi_trong_nam_theo_che_do", // entitledDays — số ngày được nghỉ trong năm theo chế độ
	USED_DAYS: "so_ngay_da_nghi_trong_nam", // usedDays — số ngày đã nghỉ trong năm
	REMAIN_DAYS: "so_ngay_con_lai_duoc_nghi_trong_nam", // remainDays — số ngày còn lại được nghỉ trong năm
	LEAVE_DAYS: "so_ngay_nghi", // số ngày nghỉ
	LEAVE_START_DATE: "ke_tu_ngay", // ngày bắt đầu nghỉ (leave_start_date)
	LEAVE_END_DATE: "den_het_ngay", // ngày kết thúc nghỉ
	ACTUAL_LEAVE_DAYS: "tong_so_ngay_nghi_thuc_te", // hiển thị: tổng số ngày nghỉ thực tế (chuỗi mô tả, gồm cả T7/CN/ngày lễ)
});

export default LEAVE_FIELD_CODES;
